import { render, staticRenderFns } from "./FormModal.vue?vue&type=template&id=0c702c6c&scoped=true"
import script from "./FormModal.vue?vue&type=script&lang=js"
export * from "./FormModal.vue?vue&type=script&lang=js"
import style0 from "./FormModal.vue?vue&type=style&index=0&id=0c702c6c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c702c6c",
  null
  
)

export default component.exports